import styled from 'styled-components';

/** How wide a page's column gets: a readable column, or wide for a grid of things (the games list) on a desktop. */
export const PAGE_WIDTH = 560;
export const WIDE_PAGE_WIDTH = 1120;

/** A plain content page (login, games list): one centered column. */
export const Page = styled.main`
  max-width: ${props => (props.$wide ? WIDE_PAGE_WIDTH : PAGE_WIDTH)}px;
  margin: 0 auto;
  padding: 16px 16px calc(24px + env(safe-area-inset-bottom));
`;

export const PageTitle = styled.h1`
  font-size: 26px;
  margin: 8px 0 16px;
`;

export const Panel = styled.section`
  padding: 16px;
  border-radius: var(--radius);
  background: var(--felt-raised);

  & + & {
    margin-top: 12px;
  }
`;

/** Panels side by side when there's room, stacked on a phone. */
export const PanelRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 12px;
  margin-bottom: 12px;

  & > ${Panel} + ${Panel} {
    margin-top: 0;
  }
`;

export const PanelTitle = styled.h2`
  font-size: 15px;
  margin-bottom: 10px;
  color: var(--muted);
  font-weight: 600;
`;
